import { render, staticRenderFns } from "./InformationNow.vue?vue&type=template&id=73b0789b&"
import script from "./InformationNow.vue?vue&type=script&lang=js&"
export * from "./InformationNow.vue?vue&type=script&lang=js&"
import style0 from "./InformationNow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports